export default "__VITE_ASSET__Dsz1tiVv__"